<template>
<div class="chapter">
<div class="inner_page">
<div class="body">
<section aria-labelledby="ch1" epub:type="chapter" role="doc-chapter">
<header>
<h1 class="CT"><span aria-label="1" id="pg_1" role="doc-pagebreak"><span href="#/xhtml/contents#c_ch1" id="ch1" title="Link target outside of Sample"><b><i>Introduction</i></b></span></span></h1>
</header>
<blockquote>
<p class="V">I decided to write this book after being</p>
<p class="V">asked so many times how my first book,</p>
<p class="VSB"><i>Abandoned Breaths,</i> began.</p>
<p class="V"><i>Silent Squall</i> touches upon emotional and</p>
<p class="V">physical abuse. It deals with the horror</p>
<p class="V">of finding yourself in the middle of a life</p>
<p class="V">that is ruthlessly controlled by <i>the one</i></p>
<p class="V">who professes to love you. Your mind and</p>
<p class="V">your body become bent—always at the beck</p>
<p class="V">and call of the <i>watchman.</i> You<i>r</i> self-worth</p>
<p class="V">is discarded because he strives hard to</p>
<p class="V">make sure you are void of it. You are</p>
<p class="V">broken down, sliced in slivers, and each</p>
<p class="V">day of this becomes your normalcy … <i>yet</i></p>
<p class="V"><i>you know it is not normal.</i> You hide from</p>
<p class="V">friends behind smoke and mirrors, because</p>
<p class="V">no one can know the truth. They might think</p>
<p class="V">you deserved it. You’ve become weak, but</p>
<p class="VSB">this is his plan. <i>That way you cannot flee.</i></p>
<p class="V">One day you will determine that anything</p>
<p class="V">is better than not wanting to live</p>
<p class="V">anymore. <i>And somehow you gain the</i></p>
<p class="V"><i>courage to fly.</i> You may do it silently in</p>
<p class="V">the middle of the night or you may require</p>
<p class="V">law enforcement or friends and family to</p>
<p class="V">guard your back … <i>but you fly.</i> You sever</p>
<p class="V"><span aria-label="2" id="pg_2" role="doc-pagebreak">the legal ties, yet the struggle continues</span></p>
<p class="V">because the road to freedom is long and</p>
<p class="VSB">your abuser is vicious.</p>
<p class="V">These poems and quotes are about a</p>
<p class="V">journey. An ongoing pilgrimage of finding</p>
<p class="VSB">the person I lost in the storm 30 years ago.</p>
<p class="V">Many of these quotes and poems were first</p>
<p class="V">written in a journal I began while in</p>
<p class="V">therapy. It is my hope that if you are in</p>
<p class="V">any situation similar to this that you <i>tell</i></p>
<p class="V"><i>someone.</i> I hope that this book gives you</p>
<p class="V">the courage to take flight and to begin</p>
<p class="V">living again.</p>
</blockquote>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter1.vue?13dcd666